import { FormFieldDefinition } from '@publishing-engine/domain/types/article';
import { IMySubmissionTab, MY_SUBMISSION_TABS } from 'src/constants';

// Author's tab mapping
const AUTHOR_TAB_FIELD_MAP: Record<
  FormFieldDefinition['name'],
  IMySubmissionTab
> = {
  Title: MY_SUBMISSION_TABS.SUBMISSION,
  Abstract: MY_SUBMISSION_TABS.SUBMISSION,
  Keywords: MY_SUBMISSION_TABS.SUBMISSION,
  FiguresAndTables: MY_SUBMISSION_TABS.SUBMISSION,
  Figures: MY_SUBMISSION_TABS.SUBMISSION,
  GraphicalAbstractImage: MY_SUBMISSION_TABS.SUBMISSION,
  Tables: MY_SUBMISSION_TABS.SUBMISSION,
  TitlePage: MY_SUBMISSION_TABS.SUBMISSION,
  SourceFiles: MY_SUBMISSION_TABS.SUBMISSION,
  Manuscript: MY_SUBMISSION_TABS.SUBMISSION,
  AnonymizedManuscript: MY_SUBMISSION_TABS.SUBMISSION,
  Supplementary: MY_SUBMISSION_TABS.SUBMISSION,
  LicensesAndPermissionsReproducedContent: MY_SUBMISSION_TABS.SUBMISSION,
  LicensesAndPermissionsFiles: MY_SUBMISSION_TABS.SUBMISSION,
  DataAvailabilityStatement: MY_SUBMISSION_TABS.SUBMISSION,
  EnglishTitle: MY_SUBMISSION_TABS.SUBMISSION,
  EnglishAbstract: MY_SUBMISSION_TABS.SUBMISSION,
  EnglishKeywords: MY_SUBMISSION_TABS.SUBMISSION,
  Subtitle: MY_SUBMISSION_TABS.SUBMISSION,
  EnglishSubtitle: MY_SUBMISSION_TABS.SUBMISSION
};

const TAB_FIELD_MAP = {
  editor: {},
  author: AUTHOR_TAB_FIELD_MAP,
  reviewer: {}
};

export default TAB_FIELD_MAP;
